/* eslint-disable camelcase */

const React = require('react');
const { string } = require('prop-types');
const classnames = require('classnames');
const IconWarning = require('../../../components/icons/IconWarning');

const ListItemSecondary = ({ label = '', receiver = '', error_message = null }) => {
  const classesLabel = classnames('address-label', {
    'address-label--with-receiver': receiver,
  });

  return (
    <>
      <span className={classesLabel}>{label}</span>
      {receiver && <span className="addresses-list-receiver">{receiver}</span>}
      {error_message && (
        <div className="andes-message andes-message--warning">
          <IconWarning />
          <div className="andes-message__text--warning">{error_message}</div>
        </div>
      )}
    </>
  );
};

ListItemSecondary.propTypes = {
  label: string,
  receiver: string,
  error_message: string,
};

module.exports = ListItemSecondary;
